import React, { Component } from 'react';

class BranchRow extends Component {
  constructor(props) {
    super(props);

    this.state = { branch_id: 0 };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.branch_id !== this.state.branch_id) {
      this.setState({ branch_id: nextProps.branch_id });
    }
  }

  render() {
    var searchType = this.props.searchType;
    var entity = this.props.entity;
    var distance = 0;
    var distanceTxt = '';
    if(searchType === 'distance') {
      distance = entity.distance;
      if(distance < 1) {
        distanceTxt = Math.ceil(distance * 1000) + 'm';
      } else {
        distanceTxt = Math.ceil(distance * 10) / 10 + 'km';
      }
    }

    return (
      <li className={this.state.branch_id === entity.id.toString() ? "active" : ""}>
        <p className="btxt">{entity.branchName}</p>
        <p className="km">{distanceTxt}</p>
        <p className="radios">
          <input type="radio" id={entity.id} name="branch_id" data-onessaas_branch_id={entity.onessaas_branch_id} value={entity.id} ref={ref => this._input = ref} onClick={this.props.onClick} />
          <label htmlFor={entity.id}>&nbsp;</label> 
        </p>
      </li>
    )
  }
}

export default BranchRow;